var map = {
	"./BlockContent/Css/blockcontent.scss": 80,
	"./Box/Css/box.scss": 81,
	"./ConditionalLayer/Css/conditionallayer.scss": 82,
	"./Form/Css/form.scss": 83,
	"./Logo/Css/logo.scss": 84,
	"./Navigation/Css/navigation.scss": 85,
	"./News/Css/news.scss": 86,
	"./Offcanvas/Css/offcanvas.scss": 87,
	"./Search/Css/search.scss": 88,
	"./Sitemap/Css/sitemap.scss": 89,
	"./SocialContent/Css/socialcontent.scss": 90,
	"./Stage/Css/stage.scss": 91,
	"./SubNavigation/Css/subnavigation.scss": 92,
	"./Tagcloud/Css/tagcloud.scss": 93,
	"./ToolBox/Css/toolbox.scss": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;